module.exports = __webpack_public_path__ + "static/media/72 - Gonzaguinha - Lindo Lago Do Amor.65bbeaf9.mp3";